module.exports = __webpack_public_path__ + "img/in_progress_delivery.8f20cb2e.svg";